import { ITableFields, TableFieldsValue } from './types';
import { GetRecentlyDeletedParams } from 'lib/api/recentlyDeletedApi';

export const tableFields: ITableFields[] = [
  {
    value: TableFieldsValue.TITLE,
    label: 'Title or name',
  },
  {
    value: TableFieldsValue.TYPE,
    label: 'Type',
  },
  {
    value: TableFieldsValue.CREATED_AT,
    label: 'Deleted on',
  },
  {
    value: TableFieldsValue.DAYS,
    label: 'Days Until Deleted',
  },
  {
    value: TableFieldsValue.RESTORE,
    label: 'Restore',
  },
];

export const checkIfContainsEmptyString = (params: any) =>
  Object.keys(params)
    .filter(key => params[key] !== '')
    .reduce(
      (obj, key) => {
        return {
          ...obj,
          [key]: params[key],
        };
      },
      { start: 0, limit: 10 }
    ) as GetRecentlyDeletedParams;
